import { prepareSvgForRasterization } from "utils/graphics/prepareSvgForRasterization";
import { loadImage } from "utils/graphics/loadImage";
import { drawImageOnCanvas } from "utils/graphics/drawImageOnCanvas";
import { ConvertSvgToCanvas } from "./types";

export const convertSvgToCanvas: ConvertSvgToCanvas = async ({
  svgElement,
}) => {
  const { svgUrl, svgProperties, revokeSvgUrl } =
    await prepareSvgForRasterization({
      svgElement,
    });

  try {
    const image = await loadImage({ imageUrl: svgUrl });

    const canvas = drawImageOnCanvas({
      image,
      width: svgProperties.width,
      height: svgProperties.height,
    });

    return canvas;
  } finally {
    revokeSvgUrl();
  }
};
